/**
 * Old admin pages whose tools now live on the Strategies page. Their links and
 * bookmarks land on Strategies, opened where that tool now is.
 */
export const BRAND_STRATEGIES_PANE_KEY = 'risklo.brandStrategies.pane';
export const OPEN_ADD_STRATEGY_KEY = 'risklo.brandStrategies.openAdd';

export const RETIRED_STRATEGY_PAGES = {
  'admin-strategy-submission': 'add',
  'admin-live-strategy': 'add',
  'admin-equity-strategies': 'list',
  'admin-nt8-webhook-mapping': 'webhooks',
};

/** Sets up the Strategies page for `page`; true when `page` was one of the old ones. */
export function prepareRetiredPageRedirect(page) {
  const where = RETIRED_STRATEGY_PAGES[page];
  if (!where) return false;
  try {
    window.localStorage.setItem(BRAND_STRATEGIES_PANE_KEY, where === 'webhooks' ? 'webhooks' : 'strategies');
    if (where === 'add') window.sessionStorage.setItem(OPEN_ADD_STRATEGY_KEY, '1');
  } catch (_e) { /* storage blocked: lands on Strategies as it was */ }
  return true;
}
